// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class State_abstract extends BaseObject {
  static $t: string = 'SagaBase.State';
  $t: string = 'SagaBase.State';

  public static GetMembers(): string[] {
    return ['StateUID', 'IsEditable', 'IsVisible', 'DisplayText'];
  }

  public GetMembers(): string[] {
    return State_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public StateUID: Guid = GuidTools.Empty;
  public IsEditable: boolean;
  public IsVisible: boolean;
  public DisplayText: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
